import { z } from 'zod';
import { BaseEntity, Currency, WithBaseEntitySchema } from '@40seas/models';
import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { InsuranceProvider } from '../insurance';

export const InsuranceCoverRequestSchema = WithBaseEntitySchema(
    z.object({
        buyer: z.string(),
        provider: z.string(),
        requestedAmount: z.number(),
        currency: EnumSchema(Currency),
    }),
).strict();

export class InsuranceCoverRequest extends FromSchema(InsuranceCoverRequestSchema) implements BaseEntity {
    id: string;
    buyer: string;
    provider: InsuranceProvider | string;

    requestedAmount: number;
    currency: Currency;

    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    createdBy?: Executor;
    seller?: string | Seller;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
